var exports = {
  "k": "xcc377c0b--1fe7d4--container",
  "w": "xcc377c0b--1fe7d4--agents-title",
};

module.exports = exports;
